import { Modal } from "antd";
import { ReactElement } from "react";
import { IpropsBankModalList } from "../../../../interfaces/props/IpropsBankModalList";

import classes from "./BankModalList.module.css";

/**
 * Компонент модального окна для отображения списка банков.
 *
 * @param {IpropsBankModalList} props - Свойства компонента.
 * @param {boolean} props.isModalOpen - Флаг отображения модального окна.
 * @param {() => void} props.handleCancel - Функция, вызываемая при закрытии модального окна.
 * @param {() => void} props.handleOk - Функция, вызываемая при подтверждении в модальном окне.
 * @param {ReactElement} props.children - Содержимое модального окна.
 */
export function BankModalList(props: IpropsBankModalList): ReactElement {
  const { isModalOpen, handleCancel, handleOk, children, okButtonProps } =
    props;
  return (
    <Modal
      title="Банки"
      cancelText="Отменить"
      okText="Ок"
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      className={classes.bankModalList}
      width="max-content"
      okButtonProps={okButtonProps}
    >
      {children}
    </Modal>
  );
}
